import React from 'react';
import './About.css';
function About() {
  return (
    <>
    
    <div className='desc'>
    <h1 className='title'>About</h1>
    <br></br>
      <div>Website to share clips with the boys</div>
      <img src="https://cdn.7tv.app/emote/643e1d3031e0e987c69ff566/2x.webp" alt="nuggietogeth"></img>
    </div>
    </>
  )
}

export default About